
import { useEffect, useRef, type RefObject } from 'react';
import { applyDoubleParenSmiliesToElement } from '@/lib/rich-text-double-paren-smilie';

export function useRichEditorDoubleParenSmilie(
  editorRef: RefObject<HTMLElement | null>,
  sync: () => void,
  disabled?: boolean,
) {
  const gen = useRef(0);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const el = editorRef.current;
    if (!el || disabled) return;

    const onInput = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        const my = ++gen.current;
        try {
          const changed = await applyDoubleParenSmiliesToElement(el);
          if (my !== gen.current) return;
          if (changed) sync();
        } catch {
          /* ignora rede / parsing */
        }
      }, 420);
    };

    el.addEventListener('input', onInput);
    return () => {
      clearTimeout(timer.current);
      el.removeEventListener('input', onInput);
    };
  }, [editorRef, sync, disabled]);
}
